// extracted by mini-css-extract-plugin
export default {"layoutRoot":"AppLayout_layoutRoot__yemFy","mainWrapper":"AppLayout_mainWrapper__BkE5z","sidebarOpen":"AppLayout_sidebarOpen__YRLST","contentArea":"AppLayout_contentArea__2cere"};